var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    height: 121.89,
    width: 800,
    viewBox: "0 0 800 121.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5",
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m765.45 119.78h34.55l-35.65-117.66-49.1-0.002-35.65 117.66h34.56l6.3-21.78h38.66l6.33 21.78m-37.51-47.943l11.76-40.651h0.2l11.76 40.651h-23.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m172.48 121.89c35.48 0 52.63-6.25 55.06-38.265 0.58-7.618 0.69-15.439 0.69-22.689 0.01-7.225-0.11-15.054-0.69-22.671-2.43-32.025-19.58-38.265-55.06-38.265s-52.62 6.24-55.04 38.265c-0.59 7.617-0.71 15.446-0.71 22.671 0.01 7.25 0.12 15.071 0.71 22.689 2.42 32.015 19.56 38.265 55.04 38.265m-22.31-60.954c0-6.461 0.16-10.28 0.3-13.114 0.9-18.161 8.07-20.278 22.01-20.278 13.95 0 21.12 2.117 22.01 20.278 0.14 2.833 0.31 6.652 0.31 13.114 0 6.482-0.17 10.308-0.31 13.135-0.89 18.164-8.06 20.285-22.01 20.285-13.94 0-21.11-2.121-22.01-20.285-0.14-2.827-0.3-6.653-0.3-13.135z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "polyline11",
    points: "0 2.172 0 31.503 35.172 31.503 35.172 119.83 70.357 119.83 70.357 31.503 105.53 31.503 105.53 2.172 0 2.172"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "polyline13",
    points: "539.85 119.78 539.85 2.118 506.46 2.118 506.46 119.78 539.85 119.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "polyline15",
    points: "405.5 45.077 405.5 2.118 372.3 2.118 372.3 119.78 405.5 119.78 405.5 74.408 444.08 74.408 444.08 119.78 477.27 119.78 477.27 2.118 444.08 2.118 444.08 45.077 405.5 45.077"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m649.67 58.283c14.79-3.781 19.13-12.616 19.13-25.386 0-25.859-16.27-30.78-39.4-30.78h-59.95v117.66h62.92c28.97 0 38.71-12.48 38.71-31.675 0-13.383-3.06-25.191-21.41-29.822m-47.03 13.169h23.02c9.3 0 11.24 4.074 11.24 10.7 0 6.632-3.64 10.717-11.24 10.717h-23.02v-21.417zm0-42.425h23.02c6.01 0 9.73 2.851 9.73 9.708 0 5.878-3.68 9.496-9.73 9.496h-23.02v-19.204z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m247.58 81.167h31.65c0.03 5.708 0.76 9.523 3.53 11.63 3.15 2.374 5.97 3.158 15.32 3.158 9 0 18.86 0 18.86-11.085 0-8.742-5.51-10.737-15.68-11.279-25.22-1.336-34.34-2.049-43.73-9.025-6.4-4.757-9.72-14.018-9.72-26.542 0-21.297 7.43-28.768 18.15-33.981 11.06-5.381 54.47-5.381 66.15 0 14.69 6.768 15.12 21.42 15.12 35.011h-31.57c-0.06-6.929-1.62-8.886-2.89-10.175-3.28-2.908-7.95-3.522-14.69-3.522-8.16 0-17.6 0.368-17.6 10.277 0 7.56 3.27 10.72 11.85 11.276 11.79 0.754 35.02 1.497 43.3 6.383 11.61 6.867 14.62 16.159 14.62 31.319 0 21.908-7.84 28.338-18.75 33.158-12.59 5.56-54.64 5.56-68.31-0.43-15.3-6.67-15.61-19.964-15.61-36.173"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.6c6527af5eda0c89bc5894499a5cc68d.svg";
export { ForwardRef as ReactComponent };